// Handles legacy routes to exercise content.
// We used to have exercise routes in two forms:
// /exercise/slug
// /exercises?exid=slug
//
// The new modal form is:
// /domain/course/unit/lesson/e/slug
//
// Since based on the information we have in the URL we don't know the full
// path, we just rewrite this URL to the /e/<slug> form, which will be
// redirected by the content library.
//
// We no longer have internal references to this form, but there are plenty
// of external requests. This handler can be removed when we no longer receive
// outside requests to /exercise/ or /exercises routes
import * as React from "react";
import {Redirect} from "react-router-dom";

type Props = {
    exerciseSlug: string | null | undefined;
    search: string;
};

export default function LegacyModalRedirect({
    exerciseSlug,
    search,
}: Props): React.ReactElement {
    const params = new URLSearchParams(search);
    if (!exerciseSlug) {
        exerciseSlug = params.get("exid");
    }

    if (!exerciseSlug) {
        return <Redirect to="/" />;
    }

    // If exid is in the query params, remove it since it is already handled
    // in the new URL. We'll want to maintain any other query params.
    if ("exid" in params) {
        params.delete("exid");
    }

    return <Redirect to={`/e/${exerciseSlug}?${params.toString()}`} />;
}
